import NavBar from "../../../components/navBar";
import { useAppContext } from "context/AppContext";

type LayoutProps = {
    children: React.ReactNode;
};

const Layout = ({ children }: LayoutProps) => {
    const { isApp } = useAppContext();

    return (
        <div className="flex flex-col relative flex-1">
            {!isApp && (
                <div className="flex justify-center fixed top-0 left-0 w-full z-30 bg-white">
                    <NavBar
                        transport={[
                            { label: "국제특송 서비스", path: "/transport/express" },
                            { label: "항공카고&해운 서비스", path: "/transport/air-sea" },
                            { label: "전시화물 서비스", path: "/transport/exhibition" },
                            { label: "주요 CLIENT 현황", path: "/transport/clients" },
                            { label: "전시회 운송 현황", path: "/transport/exhibitions" },
                        ]}
                        customer={[
                            { label: "거래내역조회", path: "/customer/transactions" },
                            { label: "화물추적조회", path: "/customer/tracking" },
                            { label: "청구서조회", path: "/customer/invoices" },
                            { label: "화물픽업예약", path: "/customer/pickup" },
                            { label: "운송견적문의", path: "/customer/estimate" },
                        ]}
                        support={[
                            { label: "공지사항", path: "/support/notices" },
                            { label: "BL작성법", path: "/support/bl-guide" },
                            { label: "운송장 및 부자재 요청", path: "/support/supplies" },
                            { label: "일신그룹 고객센터", path: "/support/tels" },
                        ]}
                    />
                </div>
            )}
            {/* <div className="w-full">{children}</div> */}
            {children}
        </div>
    );
};

export default Layout;
